/**
 * Re-export del módulo refactorizado de generación de invitaciones.
 *
 * La implementación real está en ./generarInvitaciones/index.js
 * Este archivo existe por compatibilidad con imports existentes:
 *   import { useGenerarInvitaciones, PASO_ZONA } from '@/composables/front/perfil/useGenerarInvitaciones'
 *
 * Si estás tocando lógica del stepper, trabajá en la carpeta generarInvitaciones/.
 */
export {
    useGenerarInvitaciones,
    PASO_ZONA,
    PASO_BUTACAS,
    PASO_DATOS,
    PASO_RESUMEN,
    PASO_PAGO,
    TOTAL_PASOS,
} from './generarInvitaciones';
